var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M60.472 50.304H42.864L28.728 25.504L42.864 0.703979H60.472L47.328 25.504L60.472 50.304ZM32.076 50.304H14.468L0.332031 25.504L14.468 0.703979H32.076L18.932 25.504L32.076 50.304Z","fill":"#010101"}));
}

QuoteInline.defaultProps = {"width":"61","height":"51","viewBox":"0 0 61 51","fill":"none","preserveAspectRatio":"xMidYMid"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
